import React from "react";
import {Skeleton, Box} from "@mui/material";
import FlexBox from "view/components/Layout/FlexBox";

const LoadingSkeleton = () => (
  <FlexBox
    column
    gap={1}
    paddingY={2}
    paddingX={2}
    style={{borderBottom: "1px solid #f0f0f0"}}
  >
    <FlexBox alignCenter gap={1.5}>
      <Skeleton variant="circular" width={8} height={8} />
      <Skeleton variant="text" width="60%" height={24} />
    </FlexBox>

    <Box paddingLeft={2.5}>
      <Skeleton variant="text" width="40%" height={20} />

      <FlexBox justifyBetween alignCenter marginTop={1}>
        <Skeleton variant="text" width="80px" height={18} />
        <Skeleton
          variant="rectangular"
          width={70}
          height={20}
          sx={{borderRadius: 1}}
        />
      </FlexBox>
    </Box>
  </FlexBox>
);

const NotificationBarLoader = ({count = 4}: {count?: number}) => {
  return (
    <FlexBox column width="100%">
      {Array.from({length: count}).map((_, idx) => (
        <LoadingSkeleton key={idx} />
      ))}
    </FlexBox>
  );
};

export default NotificationBarLoader;
